<template>
  <v-container fluid
    ><div class="settings-section">
      <div class="center">
        <h2>{{ $t("app.settings.general.title") }}</h2>
      </div>
      <div>
        <a v-if="this.$store.getters.user.role === 'p' || this.$store.getters.user.role === 'o'" href="/settings/editProfile">
          <ListItem>
            <span class="valign-middle">{{
                $t("app.settings.general.editProfile")
              }}</span>
          </ListItem>
        </a>
        <!-- <a :href="`/change/password?token=`">
          <ListItem :last="this.$store.getters.user.role === 'o'">
            <span class="valign-middle">{{
              $t("app.settings.general.pass")
            }}</span>
          </ListItem>
        </a> -->
<!--        <ListItem
          v-if="$store.getters.user.role === 'p' && downloadEnabled.toLowerCase() === 'true'"
          @click.native="downloadData('posts')"
          ><span class="valign-middle">{{
            `${$t("app.settings.general.export-1a")} ${
              this.$store.getters.user.patient.firstName
            } ${$t("app.settings.general.export-1b")}`
          }}</span>
        </ListItem>-->
<!--        <ListItem
          v-if="$store.getters.user.role === 'p'"
          @click.native="downloadData('all')"
          ><span class="valign-middle">{{
            `${$t("app.settings.general.export-2a")} ${
              this.$store.getters.user.patient.firstName
            } ${$t("app.settings.general.export-2b")}`
          }}</span></ListItem
        >-->
        <a href="/settings/language?display=0">
          <ListItem>
            <span class="valign-middle">{{
              $t("app.settings.general.display-language")
            }}</span>
          </ListItem>
        </a>
        <a href="/settings/translation-language" v-if="deepl">
          <ListItem last="true">
            <span class="valign-middle">{{
              $t("app.settings.general.translate-language")
            }}</span>

          </ListItem>
        </a>
      </div>
    </div>
    <div v-if='deepl' v-html="disclaimer">
    </div>
    <div class="settings-section">
      <div class="center">
        <h2>{{ $t("app.settings.notifications.title-in-app") }}</h2>
      </div>
      <ListItem
        toggle
        v-model="notifications.newPostsNotification"
        @toggle-setting="writeSettings"
      >
        <span class="valign-middle">{{ $t("app.settings.notifications.new-posts") }}</span>
      </ListItem>
      <ListItem
        :last="this.$store.getters.user.role === 'o'"
        toggle
        v-model="notifications.newMilestonesNotification"
        @toggle-setting="writeSettings"
      >
        <span class="valign-middle">{{ $t("app.settings.notifications.new-milestones") }}</span>
      </ListItem>
      <ListItem
        v-if="this.$store.getters.user.role === 'p'"
        toggle
        v-model="notifications.commentsNotification"
        @toggle-setting="writeSettings"
      >
        <span class="valign-middle">{{ $t("app.settings.notifications.comments") }}</span>
      </ListItem>
      <ListItem
        v-if="this.$store.getters.user.role === 'p'"
        toggle
        v-model="notifications.likeNotification"
        last="true"
        @toggle-setting="writeSettings"
      >
        <span class="valign-middle">{{ $t("app.settings.notifications.likes") }}</span>
      </ListItem>
    </div>
    <div class="settings-section">
      <div class="center">
        <h2>{{ $t("app.settings.notifications.title-external") }}</h2>
      </div>
      <ListItem
        toggle
        v-model="notifications.postsViaMail"
        @toggle-setting="writeSettings"
        :disabled="!this.$store.getters.user.hospital.notificationSettings.postsViaMail"
      >
        <span class="valign-middle">
          {{ $t("app.settings.notifications.new-posts-via-mail") }}
          <span class="text-caption"  v-if="!this.$store.getters.user.hospital.notificationSettings.postsViaMail">({{ $t("app.settings.notifications.disabled-by-hospital") }})</span>
        </span>
      </ListItem>
      <ListItem
        :last="this.$store.getters.user.role === 'o'"
        toggle
        v-model="notifications.visitUpdatesViaMail"
        @toggle-setting="writeSettings"
        :disabled="!this.$store.getters.user.hospital.notificationSettings.visitUpdatesViaMail"
      >
        <span class="valign-middle">
          {{ $t("app.settings.notifications.visit-updates-via-mail") }}
                <span class="text-caption" v-if="!this.$store.getters.user.hospital.notificationSettings.visitUpdatesViaMail">({{ $t("app.settings.notifications.disabled-by-hospital") }})</span>
        </span>
      </ListItem>
    </div>

    <!--    <div class="settings-section" v-if="$store.getters.user.role === 'p'">
          <div class="center">
            <h2>{{ $t("app.settings.reminders.title") }}</h2>
          </div>
          <ListItem
            toggle
            v-model="reminders.plannedVisitReminder"
            last="true"
            @toggle-setting="writeSettings"
            ><span class="valign-middle">{{ $t("app.settings.reminders.visit") }}</span></ListItem
          >
        </div>-->


    <div class="settings-section">
      <div class="center">
        <h2>{{ $t("app.settings.support.title") }}</h2>
      </div>
      <a :href="manualUrl" target="_blank">
        <ListItem><span class="valign-middle">{{ $t("app.settings.support.faq") }}</span></ListItem>
      </a>
      <a href="/settings/feedback">
        <ListItem><span class="valign-middle">{{ $t("app.settings.support.feedback") }}</span></ListItem>
      </a>
      <a href="/settings/reportProblem">
        <ListItem last="true"><span class="valign-middle">{{ $t("app.settings.support.problemReport") }}</span></ListItem>
      </a>
    </div>

    <div class="settings-section">
      <div class="center">
        <h2>{{ $t("app.settings.privacy.title") }}</h2>
      </div>
      <a
        v-if="this.$store.getters.user.hospital.useCuraeConsent"
        :href="'/api/consent/url'"
      >
        <ListItem><span class="valign-middle">{{ $t("app.settings.privacy.consent") }}</span></ListItem>
      </a>
      <a
        :href="'https://leapstation.eu/neoparent/Neoparent-privacyverklaring.pdf'"
        target="_blank"
      >
        <ListItem><span class="valign-middle">{{ $t("app.settings.privacy.info") }}</span></ListItem>
      </a>
    </div></v-container
  >
</template>

<script>
import { neoparentUsers, neoparentPatients } from "@/api";
import {getSupportedLocales} from "@/helpers";
import axios from "axios";

import disclaimers from './settings/disclaimers.json'
export default {
  name: "neoparent-settings",
  props: ['manual-url'],
  data() {
    return {
      deepl: this.$store.getters.user.hospital.hasDeepl,
      notifications: {
        newPostsNotification: this.$store.getters.user.newPostsNotification,
        newMilestonesNotification: this.$store.getters.user
          .newMilestonesNotification,
        commentsNotification: this.$store.getters.user.commentsNotification,
        likeNotification: this.$store.getters.user.likeNotification,
        postsViaMail: this.$store.getters.user.notificationSettings.postsViaMail,
        visitUpdatesViaMail: this.$store.getters.user.notificationSettings.visitUpdatesViaMail
      },
      reminders: {
        visitReminder: this.$store.getters.user.visitReminder,
        lengthWeightReminder: this.$store.getters.user.lengthWeightReminder,
        plannedVisitReminder: this.$store.getters.user.plannedVisitReminder
      },
      privacy: {
        googleAnalytics: this.$store.getters.user.googleAnalytics
      },
    };
  },
  mounted() {
  },
  computed: {
    disclaimer() {
      var lang = (this.$store.getters.user.translationLanguage || '').substring(0, 2);
      let res = disclaimers[lang]
      if (res) {
        return res
      } else {
        return disclaimers['en'];
      }
    }
  },
  methods: {
    writeSettings() {
      neoparentUsers
        .editUserSettings(this.$store.getters.user.id, {
          notifications: this.notifications,
          reminders: this.reminders,
          privacy: this.privacy
        })
        .then(result => {
          this.$store.commit('updateUser', result.data.parent)
        })
        .catch(err => {
          this.consoleLog(err);
        });
    },
    downloadData(download) {
      // TODO Export patient data
      if (download !== "all" && download !== "posts") return;
      switch (download) {
        case "all":
          neoparentPatients
            .getExportForAllData(this.$store.getters.user.patient.id)
            .then(result => {
              this.consoleLog(result);
            })
            .catch(err => {
              this.consoleLog(err);
            });
          break;
        case "posts":
          neoparentPatients
            .getExportForPostData(this.$store.getters.user.language, this.$store.getters.user.patient.id)
            .then(result => {
              // this.consoleLog(result);
              const url = window.URL.createObjectURL(result.data);
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', this.$t('app.settings.general.export-1a') + ' ' + this.$store.getters.user.patient.firstName + '.pdf');
              document.body.appendChild(link);
              link.click();
            })
            .catch(err => {
              this.consoleLog(err);
            });
          break;

        default:
          break;
      }
      // try {
      //   window.open(
      //     `${this.$backendRoot}/patients/${
      //       this.$session.get("patient").id
      //     }/export/${download}?token=${this.$session.get("token")}`
      //   );
      // } catch (error) {
      //   this.consoleLog(error);
      // }
    },
    formatDate(dateString) {
      return this.$moment(dateString).format("L");
    }
  }
};
</script>

<style scoped lang="scss"></style>
